import React from 'react';
import CTAButton from '../CTAButton';

const ITFinalCTA = ({
    title = "Build Scalable Teams For Innovation",
    description = "",
    buttonText = "Partner With Us Now",
    onCtaClick
}) => {
    return (
        <section className="py-24 bg-white relative overflow-hidden">
             <div className="container mx-auto px-6 text-center relative z-10 max-w-4xl ">
                <h2 className="text-3xl md:text-3xl font-bold text-[#01014C] syne mb-6 leading-tight">
                    {title}
                </h2>
                {description && (
                    <p className="text-[#01014C] text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
                        {description}
                    </p>
                )}
                <CTAButton 
                    text={buttonText}
                    onClick={onCtaClick}
                />
             </div>
        </section>
    );
};

export default ITFinalCTA;